@if (labelAbove()) {
<label [formGroup]="parentForm()" class="body1 label-above">
  <div class="label-row">
    <div>
      {{ field().label }}
      @if (field().required) {
        <span class="required" aria-required="true"> * </span>
      }
    </div>
    @if (displayTooltip()) {
      <div class="minMaxValues" role="tooltip">
        <mat-icon
          class="info"
          [class.disabled]="parentForm()?.controls[field().key]?.disabled"
          >info</mat-icon
        >
        <div class="top">
          Min: {{ minValue() }}<br />Max: {{ maxValue() }}<br />
          {{ tooltipText() }}
          <i></i>
        </div>
        <div class="tooltip-accessibility">
          Min: {{ minValue() }}<br />Max: {{ maxValue() }}
        </div>
      </div>
    }
  </div>
  <div class="input-container">
    <input
      [id]="field().key"
      [placeholder]="field().placeholder"
      type="number"
      [formControlName]="field().key"
      [autocomplete]="field().autocomplete"
      [required]="field().required"
      [class.disabled]="parentForm()?.controls[field().key]?.disabled"
      [attr.aria-required]="field().required"
      [step]="step()"
    />
    <div class="button-container">
      <button
        [id]="field().key + 'plus'"
        class="plus-button"
        (click)="plusButtonClicked()"
        [disabled]="parentForm()?.controls[field().key]?.disabled"
        [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        type="button"
      >
        <mat-icon>arrow_drop_up</mat-icon>
      </button>
      <button
        [id]="field().key + 'minus'"
        class="minus-button"
        (click)="minusButtonClicked()"
        [disabled]="parentForm()?.controls[field().key]?.disabled"
        [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        type="button"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>
</label>
} @else {
<label [formGroup]="parentForm()" class="body1">
  <div>
    {{ field().label }}
    @if (field().required) {
      <span class="required" aria-required="true"> * </span>
    }
  </div>
  <div class="input-container">
    <input
      [id]="field().key"
      [placeholder]="field().placeholder"
      type="number"
      [formControlName]="field().key"
      [autocomplete]="field().autocomplete"
      [required]="field().required"
      [class.disabled]="parentForm()?.controls[field().key]?.disabled"
      [attr.aria-required]="field().required"
      [step]="step()"
    />
    <div class="button-container">
      <button
        [id]="field().key + 'plus'"
        class="plus-button"
        (click)="plusButtonClicked()"
        [disabled]="parentForm()?.controls[field().key]?.disabled"
        [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        type="button"
      >
        <mat-icon>arrow_drop_up</mat-icon>
      </button>
      <button
        [id]="field().key + 'minus'"
        class="minus-button"
        (click)="minusButtonClicked()"
        [disabled]="parentForm()?.controls[field().key]?.disabled"
        [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        type="button"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>
  @if (displayTooltip()) {
    <div class="minMaxValues" role="tooltip">
      <mat-icon
        class="info"
        [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        >info</mat-icon
      >
      <div class="top">
        Min: {{ minValue() }}<br />Max: {{ maxValue() }}<br />
        {{ tooltipText() }}
        <i></i>
      </div>
      <div class="tooltip-accessibility">
        Min: {{ minValue() }}<br />Max: {{ maxValue() }}
      </div>
    </div>
  }
</label>
}
@if (hasErrors) {
<mat-error>
    {{ errorsList[0] }}
  </mat-error>
}
@if (showWarning()) {
<mat-error class="warning">
    {{ warningMessage() }}
  </mat-error>
}
